import { css, Interpolation, Theme } from '@emotion/react'

export const wrapper: Interpolation<Theme> = css`
  width: 100%;
  padding: 24px;
`

export const title: Interpolation<Theme> = css`
  font-weight: 700;
  margin-bottom: 24px;
`

export const tableHeader: Interpolation<Theme> = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 14px;
`

export const tableTitle: Interpolation<Theme> = css`
  font-weight: 600;
`

export const link: Interpolation<Theme> = (theme: Theme) => css`
  color: ${theme.colors.blueHover};
`
